function getContactApiBase() {
  const raw = process.env.REACT_APP_CONTACT_API_URL;
  if (typeof raw !== 'string' || !raw.trim()) {
    throw new Error(
      'Missing REACT_APP_CONTACT_API_URL. Set it in frontend/.env (for example http://localhost:3001).'
    );
  }
  return raw.trim().replace(/\/$/, '');
}

export function getContactApiUrl() {
  return `${getContactApiBase()}/api/contact`;
}

export async function sendContactMessage(payload) {
  const res = await fetch(getContactApiUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    // ignore
  }
  if (!res.ok) {
    const msg = typeof data.error === 'string' ? data.error : 'Something went wrong.';
    throw new Error(msg);
  }
  return data;
}
